import { isReview, isStaging, getCanonicalUrl } from "common/utils/env";
import { datadogRum } from "@datadog/browser-rum";
import { isCrawler } from "common/utils/browser";

let environment;

if (isStaging()) {
  environment = "staging";
} else if (isReview()) {
  environment = "review";
} else {
  environment = "production";
}
if (process.env.NODE_ENV !== "test") {
  datadogRum.init({
    applicationId: "7a00a52b-fc11-4bad-96ee-4311cc46cdc8",
    clientToken: "pubaa0f44eb7916427ef0e13a746ab85fdc",
    site: "datadoghq.com",
    service: "jiffy-web",
    env: environment,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 40,
    trackBfcacheViews: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      "https://jiffy.com",
      "https://www.jiffy.com",
      "https://staging.sdtechdev.com",
      /^https:\/\/[^\/]+.\.staging\.sdtechdev\.com/ // eslint-disable-line
    ],
    beforeSend: _event => {
      // Filter out errors from Search Engine Bots that are causing noise (same pattern as Honeybadger (_honeybadger.html.erb))
      const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
      if (isCrawler(userAgent)) {
        return false;
      }

      return true;
    }
  });

  if (isReview()) {
    const reviewEnv = getCanonicalUrl().split(".")[0].split("//")[1];
    datadogRum.setGlobalContext({
      review: reviewEnv
    });
  }
}
